import Vue from 'vue'
import Vuex from 'vuex'


Vue.prototype.mapState = Vuex.mapState;

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
	showQrCode : false,
	qrCode : '',
	applyState : false,
	startTime : false,
	endTime : false,
	init : false,
	activityRule : '',
	liked : false,
	userName : '',
	userPortrait : '',
	bannerImg : '',
	pageBg : '',
	newPrice : '',
	oldPrice : '',
	price : '',
	count : '',
    report_url: '',
    selected: [],
	sqrCount : '',
	pageBgStyle : {},
    pageRecordUrl: '',
    showApplyform: false,
    tid: '',
    detail_rule_pc: '',
    hasCoupon: false,
    couponTitle: '',
    couponImg: '',
    couponUrl: '',
    site_yhxy: '',
    miniapp: false,
    showShare: false,
  },
  mutations: {

	setPageBgStyle(state,val){
		state.pageBgStyle = val;
	},
	setApplyState(state,val){
		state.applyState = val;
	},

	setPageRecordUrl(state,val){
	  state.pageRecordUrl = val;
  	},
    showQrCode (state,val) {
      state.showQrCode = true;
	  if(val)state.qrCode = val.toString();
    },
	hideQrCode (state) {
	  state.showQrCode = false;
	},
	setApplyformShow(state, val) {
		state.showApplyform = val;
	},
	setState(state, payload) {
		Object.keys(payload).forEach(key => {
			state[key] = payload[key];
		});
	},
	init(state,datas){
		console.log('init store');
		console.log(datas);
		Object.keys(datas).forEach(function(item){
			Vue.set(state,item,datas[item]);
			//state[item] = datas[item];
		})

		state.init = true;
		var nowTime = new Date().getTime();
		if(state.startTime > nowTime){
			state.applyState = 'start';
		}

		if(nowTime >= state.startTime){
			state.applyState = 'ing';
		}

		if(nowTime >= state.endTime){
			state.applyState = 'end';
		}
		//state = datas;
	}


  }
})

export default store;
